<template>
   <q-dialog :visible="isVisible" title="邮递地址" width="500px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div class="row">用户名：{{address.contactsName}}</div>
      <div class="row">用户手机号：{{address.contactsPohone}}</div>
      <div class="row">邮递地址：{{address.province + address.address}}</div>
      <div class="btn-box">
        <el-button type="primary" @click="isVisible = false">关闭</el-button>
      </div>
   </q-dialog>
</template>

<script>
export default {
  props: {
    isMailAddress: {
      type: Boolean,
      default: false
    },
    id: [String,Number]
  },
  data() {
    return {
      address: {}
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.isMailAddress
      },
      set(newVal) {
        this.$emit('update:isMailAddress',newVal)
      }
    }
  },
  watch: {
    id: {
      handler(newVal) {
        console.log(newVal)
        this.getWinPrizeAdressInfo()
      }
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false
    },
    getWinPrizeAdressInfo() {
      this.$api.ActivityManagement.getWinPrizeAdressInfo(this.id)
        .then(res => {
          if (res.success) {
            this.address = res.data || {}
          }
        })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .row {
    margin-bottom: 10px;
  }
  .btn-box {
    display: flex;
    justify-content: center;
  }
</style>